// import $ from 'jquery';
import BaseView from 'picnic/core/views/Base';


var
	CLASS_OPEN = 'is-open'
;


class View extends BaseView {

	events() {
		return {
			'click .accordion-toggle': this._onOpen
		};
	}

	_onOpen(e) {
		const
			{currentTarget} = e,
			category = currentTarget.getAttribute('data-category') || window.kleinanzeigen.trackingIdentifier,
			action = currentTarget.getAttribute('data-action'),
			label = currentTarget.getAttribute('data-label')
		;

		e.preventDefault();
		this.$el.toggleClass(CLASS_OPEN);

		if (category && action && label) {
			this.context.dispatch('accordion:toggle', {category, label, action});
		}
	}

}

export default View;
